import api from "../utils/api";

/**
 * Fee Management API Service
 */

// 📊 Dashboard statistics
export const getDashboardStats = (params = {}) => {
  return api.get("/api/fees/dashboard-stats", { params });
};

// 📋 Students fee overview list (with class dropdown, search, pagination, status)
export const getStudentsFeeList = (params = {}) => {
  return api.get("/api/fees/students", { params });
};

// 🔍 Single student fee details, monthly records, and transactions
export const getStudentFeeDetails = (studentId) => {
  return api.get(`/api/fees/student/${studentId}`);
};

// ⚙️ Configure student admission and monthly recurring fee structure
export const configureStudentFee = (studentId, data) => {
  return api.post(`/api/fees/student/${studentId}/configure`, data);
};

// 💳 Record payment for admission fee or monthly fee obligation
export const recordPayment = (studentId, data) => {
  return api.post(`/api/fees/student/${studentId}/record-payment`, data);
};

// 🧾 Fetch single payment receipt by receipt number
export const getReceipt = (receiptNumber) => {
  return api.get(`/api/fees/receipt/${receiptNumber}`);
};

// 📑 Comprehensive fee reports (10 report types)
export const getFeeReports = (params = {}) => {
  return api.get("/api/fees/reports", { params });
};

// 🏫 Class-level fee structure APIs
export const getClassFeeStructure = (classId) => {
  return api.get(`/api/fees/class/${classId}`);
};

export const getAllClassFeeStructures = () => {
  return api.get("/api/fees/classes/overview");
};

export const configureClassFee = (classId, data) => {
  return api.post(`/api/fees/class/${classId}/configure`, data);
};

